export default __webpack_public_path__ + "static/media/proposal-confirmed.a95c82f5.svg";